import React from 'react'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { TimerMode } from '@/components/settings/timer-configuration/types'
import { cn } from '@/lib/utils'

interface TimerModeSelectorProps {
  mode: TimerMode
  onModeChange: (mode: TimerMode) => void
  disabled?: boolean
  showSingleAdvisorRound: boolean
  inline?: boolean
}

export const TimerModeSelector: React.FC<TimerModeSelectorProps> = ({
  mode,
  onModeChange,
  disabled = false,
  showSingleAdvisorRound,
  inline = false,
}) => {
  const selectElement = (
    <Select
      value={mode}
      onValueChange={(value) => onModeChange(value as TimerMode)}
      disabled={disabled}
    >
      <SelectTrigger className={cn('w-full', !inline && 'max-w-md')}>
        <SelectValue placeholder='Select timer mode' />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={TimerMode.SINGLE_ROUND}>Single Round</SelectItem>
        <SelectItem
          value={TimerMode.SINGLE_ROUND_ADVISOR_ONLY}
          disabled={!showSingleAdvisorRound}
        >
          Single Round (Advisor Only)
        </SelectItem>
        <SelectItem value={TimerMode.MULTI_ROUND_ALL}>
          Multi-Round (All Features)
        </SelectItem>
        <SelectItem value={TimerMode.MULTI_ROUND_NEGOTIATION_LOCKED}>
          Multi-Round (Negotiation Locked)
        </SelectItem>
        <SelectItem value={TimerMode.MANUAL_MODE}>Manual Mode</SelectItem>
        <SelectItem value={TimerMode.TEAM_MODE}>Team Mode</SelectItem>
        <SelectItem value={TimerMode.RESEARCH_MODE}>Research Mode</SelectItem>
      </SelectContent>
    </Select>
  )

  const label = (
    <Label htmlFor='timer-mode' className='font-medium'>
      Timer Mode
    </Label>
  )

  if (inline) {
    return (
      <div className='grid grid-cols-4 items-center gap-4'>
        {label}
        <div className='col-span-3'>{selectElement}</div>
      </div>
    )
  }

  return (
    <div className='flex flex-col space-y-2'>
      {label}
      {selectElement}
    </div>
  )
}
